import { render, staticRenderFns } from "./VocabularySession.vue?vue&type=template&id=262d3c1a&scoped=true"
import script from "./VocabularySession.vue?vue&type=script&lang=js"
export * from "./VocabularySession.vue?vue&type=script&lang=js"
import style0 from "./VocabularySession.vue?vue&type=style&index=0&id=262d3c1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262d3c1a",
  null
  
)

export default component.exports